import React, { useState, useEffect, useRef } from 'react';
import { uploadFiles, createJob } from '../api/api';
import { callMsGraph } from '../utils/MsGraphApiCall';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Typography, Box } from '@mui/material';

const guideline_calculator = () => {
  return (
    <div className="container" style={{paddingBottom: '2em'}}>
          <style>
            {`
             @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
              .container-fluid {
                padding-right: 0 !important;
                padding-left: 0 !important;
              }
              .home-banner img {
                display: block;
                margin: 0 auto;
              }
              body {
                font-family: 'Roboto';
              }
            `}
        </style>       
        <h3 style={{ marginBottom: "10px", color: "#009EDB",  paddingTop: '1em', paddingBottom: '5px'}}>
            Guidelines
            </h3>            
            <ul>
           <li> To initiate a calculation process for footprint indicators, you should create a new footprint calculation job through the <strong>Create Jobs</strong> tab.
            </li>
            <li>
             To monitor the status of calculations and download results, use the <strong>View Jobs</strong> tab. Your job may have one of the following four statuses: 
            <ul>
              <li>
              <strong>Waiting</strong> – is reflecting the Global Footprint Tool’s preparatory process to begin the calculation after uploading your national data.
              </li>
              <li>
              <strong>Running</strong> – is reflecting the process during which the Global Footprint Tool is actively performing the calculation using your national data and GLORIA MRIO.
              </li>
              <li>
              <strong>Completed</strong> – a message indicating the successful completion of the calculation. You can now download the final results. 
              </li>
              <li>
              <strong>Failed</strong> – an error message during the calculation process. In this case, we recommend re-downloading the Excel input_template file, providing all the necessary information again, including completion of the “Config” sheet as recommended in the template, and then uploading it to the Footprint Tool Calculator. If the error persists, please contact us at unep-oos-sdgs@un.org.
              </li>
              </ul>
            </li>
            </ul>
            <p>For more information, please refer to the <a href="https://wedocs.unep.org/items/d8757c79-c577-44b8-99a1-1c1ac3760e4d" target="_blank" rel="noopener noreferrer">Global Footprint Tool User Guide</a>.</p>
         
    </div>
  );
};

export default guideline_calculator;